module.exports = __webpack_public_path__ + "img/863243460ad6346432651ec169c46238.6cdc7ee7.jpg";